/**
 * `inquiry_email_source` quedó de compat: el diálogo de compartir ya no lo
 * manda ni lo elige. El To de la consulta lo resuelve el backend (mail de la
 * identidad del share, o el de la cuenta del dueño).
 *
 * El PATCH de showroom sigue copiando la clave si viene, porque omitirla
 * conserva el valor viejo. Contrato: `FRONTEND_BRANDS.md`.
 */

export const INQUIRY_EMAIL_SOURCE_BRAND = 'brand';
export const INQUIRY_EMAIL_SOURCE_COMPANY = 'company';
export const INQUIRY_EMAIL_SOURCE_OWNER = 'owner';

export const INQUIRY_EMAIL_SOURCES = [
  INQUIRY_EMAIL_SOURCE_BRAND,
  INQUIRY_EMAIL_SOURCE_COMPANY,
  INQUIRY_EMAIL_SOURCE_OWNER,
];

/**
 * Valor leído del API. `null`, vacío o desconocido equivalen a `"brand"`.
 *
 * @param {string|null|undefined} value
 * @returns {'brand'|'company'|'owner'}
 */
export function normalizeInquiryEmailSource(value) {
  if (value === INQUIRY_EMAIL_SOURCE_COMPANY) return INQUIRY_EMAIL_SOURCE_COMPANY;
  if (value === INQUIRY_EMAIL_SOURCE_OWNER) return INQUIRY_EMAIL_SOURCE_OWNER;
  return INQUIRY_EMAIL_SOURCE_BRAND;
}
